<app-loader *ngIf="loader"></app-loader>
<div class="container-fluid" [ngClass]="{ 'p-0': viewType == 'mobile' }" *ngIf="!loader">
  <div [ngClass]="{ 'row justify-content-center align-items-center min-vh-100 p-2': viewType == 'desktop' }">
    <div [ngClass]="{ 'col-sm-12 col-md-8 col-lg-4 col-xl-4 col-xxl-3': viewType == 'desktop' }">
      <div class="card login-card" [ngClass]="{ 'login-card-mobile': viewType == 'mobile' }">
        <div class="row wd-100p mx-auto text-center mb-4">
          <div class="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto wd-100p">
            <img *ngIf="logo_uri" [src]="logo_uri" width="150" height="150" class="logo-url" alt="logo" />
          </div>
        </div>
        <div class="text-center">
          <h3 class="head-title">Login to your account</h3>
          <span class="head-description">Welcome back! Select a method to login</span>
        </div>
        <div class="card-body mt-2 pb-0">
          <div class="text-danger mb-2" *ngIf="isErrorOccured">
            {{ errorDescription | titlecase }}
          </div>
          <ng-container *ngIf="publicLoginInfo.enable_classical">
            <form [formGroup]="loginForm" (ngSubmit)="onLoginSubmit()" name="loginForm"
              novalidate="novalidate">
              <div class="mt-4">
                <ng-container *ngIf="userValueTypes && userValueTypes.length">
                  <!-- Mobile -->
                  <ng-container *ngIf="showMobile && !(showEmail || showUsername)">
                    <mat-form-field appearance="outline">
                      <mat-label> Mobile Number </mat-label>
                      <input matInput type="number" id="mobile" name="mobile" formControlName="mobile" class="form-control" id="no-increment-decrement" autocomplete="off" />
                    </mat-form-field>
                    <div *ngIf="form['mobile'].touched && form['mobile'].errors" class="text-danger px-2">
                      <small *ngIf="form['mobile'].errors['required']">Mobile number is Mandatory.</small>
                      <small *ngIf="form['mobile'].errors['pattern']">Mobile number Incorrect.</small>
                    </div>
                  </ng-container>
                  <!-- Email -->
                  <ng-container *ngIf="showEmail && !(showMobile || showUsername)">
                    <mat-form-field appearance="outline">
                      <mat-label> Email Address </mat-label>
                      <input matInput type="text" id="email" name="email" formControlName="email" class="form-control" autocomplete="off" />
                    </mat-form-field>
                    <div *ngIf="form['email'].touched && form['email'].errors" class="text-danger px-2">
                      <small *ngIf="form['email'].errors['required']">Email is Mandatory.</small>
                      <small *ngIf="form['email'].errors['pattern']">Email Incorrect.</small>
                    </div>
                  </ng-container>
                  <!-- Username -->
                  <ng-container *ngIf="showUsername && !(showEmail || showMobile)">
                    <mat-form-field appearance="outline">
                      <mat-label>Username</mat-label>
                      <input
                        matInput
                        type="text"
                        id="username"
                        name="username"
                        formControlName="username"
                        class="form-control"
                        [pattern]="isMailInput ? emailPattern : mobilePattern"
                        autocomplete="off" />
                    </mat-form-field>
                    <div *ngIf="form['username'].touched && form['username'].errors" class="text-danger px-2">
                      <small *ngIf="form['username'].errors['required']">Please enter valid details</small>
                    </div>
                  </ng-container>
                  <!-- Mobile/Username -->
                  <ng-container *ngIf="((showEmail && showUsername) || (showMobile && showUsername)) && !(showEmail && showMobile && showUsername)">
                    <mat-form-field appearance="outline">
                      <mat-label *ngIf="showEmail && showMobile">Email or Mobile No</mat-label>
                      <mat-label *ngIf="showEmail && showUsername">Email or Username</mat-label>
                      <mat-label *ngIf="showMobile && showUsername">Mobile or Username</mat-label>
                      <input
                        matInput
                        type="text"
                        id="username"
                        name="username"
                        formControlName="username"
                        class="form-control"
                        [pattern]="isMailInput ? emailPattern : mobilePattern"
                        autocomplete="off" />
                      </mat-form-field>
                      <!-- (keyup)="getInput()" -->
                    <div *ngIf="form['username'].touched && form['username'].errors" class="text-danger px-2">
                      <small *ngIf="form['username'].errors['required']">Please enter valid details</small>
                      <!-- <ng-container *ngIf="isMailInput">
                        <small *ngIf="form['username'].errors['pattern']">Email Incorrect.</small>
                      </ng-container>
                      <ng-container *ngIf="!isMailInput">
                        <small *ngIf="form['username'].errors['pattern']">Mobile number Incorrect.</small>
                      </ng-container> -->
                    </div>
                  </ng-container>
                  <!-- Email/Mobile -->
                  <ng-container *ngIf="(showEmail && showMobile) && !(showEmail && showMobile && showUsername)">
                    <mat-form-field appearance="outline">
                      <mat-label *ngIf="!isMailInput">
                        {{ isNumberInput ? 'Mobile No' : 'Email or Mobile No' }}
                      </mat-label>
                      <mat-label *ngIf="isMailInput">
                        {{ isMailInput ? 'Email' : 'Mobile No' }}
                      </mat-label>
                      <input
                        matInput
                        type="text"
                        id="username"
                        name="username"
                        formControlName="username"
                        class="form-control"
                        (keyup)="getInput()"
                        [pattern]="isMailInput ? emailPattern : mobilePattern"
                        autocomplete="off" />
                    </mat-form-field>
                    <div *ngIf="form['username'].touched && form['username'].errors" class="text-danger px-2">
                      <small *ngIf="form['username'].errors['required']">Email or Mobile number is Mandatory.</small>
                      <ng-container *ngIf="isMailInput">
                        <small *ngIf="form['username'].errors['pattern']">Email Incorrect.</small>
                      </ng-container>
                      <ng-container *ngIf="!isMailInput">
                        <small *ngIf="form['username'].errors['pattern']">Mobile number Incorrect.</small>
                      </ng-container>
                    </div>
                  </ng-container>

                  <!-- Email/Mobile/Username -->
                  <ng-container *ngIf="showEmail && showMobile && showUsername">
                    <mat-form-field appearance="outline">
                      <mat-label *ngIf="showEmail && showMobile && showUsername">Email or Mobile No or Username</mat-label>
                      <!-- <mat-label *ngIf="showEmail && showUsername">Email or Username</mat-label>
                      <mat-label *ngIf="showMobile && showUsername">Mobile or Username</mat-label> -->
                      <input
                        matInput
                        type="text"
                        id="username"
                        name="username"
                        formControlName="username"
                        class="form-control"
                        [pattern]="isMailInput ? emailPattern : mobilePattern"
                        autocomplete="off" />
                      </mat-form-field>
                      <!-- (keyup)="getInput()" -->
                    <div *ngIf="form['username'].touched && form['username'].errors" class="text-danger px-2">
                      <small *ngIf="form['username'].errors['required']">Please enter valid details</small>
                    </div>
                  </ng-container>
                </ng-container>
                <!-- Email/Mobile Not Found -->
                <ng-container *ngIf="userValueTypes && userValueTypes.length == 0">
                  <mat-form-field appearance="outline">
                    <mat-label> Email Address </mat-label>
                    <input matInput type="text" id="email" name="email" formControlName="email" class="form-control" autocomplete="off" />
                  </mat-form-field>
                  <div *ngIf="form['email'].touched && form['email'].errors" class="text-danger px-2">
                    <small *ngIf="form['email'].errors['required']">Email is Mandatory.</small>
                    <small *ngIf="form['email'].errors['pattern']">Email Incorrect.</small>
                  </div>
                </ng-container>
              </div>
              <div class="mb-2 mt-3">
                <div class="position-relative">
                  <mat-form-field appearance="outline">
                    <mat-label>
                      <!-- <img src="../../assets/images/lock.svg" /> -->
                      Password
                    </mat-label>
                    <input matInput [type]="password" formControlName="password" id="password" name="password" class="form-control" />
                  </mat-form-field>
                  <button (click)="onClick()" class="btn icon position-absolute show-password" type="button">
                    <img src="../../../assets/images/profile/eye.svg" alt="Logo" width="24" height="24" *ngIf="show" />
                    <img src="../../../assets/images/profile/visibility_off.svg" alt="Logo" width="24" height="24" *ngIf="!show" />
                  </button>
                </div>
                <div *ngIf="loginForm.controls['password'].invalid && (loginForm.controls['password'].dirty || loginForm.controls['password'].touched)" class="invalid-feedback">
                  <div *ngIf="loginForm.controls['password'].errors?.['required']">Password is required.</div>
                </div>
              </div>
              <div class="row justify-content-between m-0" *ngIf="publicLoginInfo?.settings?.show_forgot_password">
                <!-- <div class="col-6 form-check">
                  <ng-container *ngIf="isShowRememberMe">
                        <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="remember_me" style="cursor: pointer" />
                        <label class="bottom-description" for="rememberMe">Remember me</label>
                      </ng-container>
                </div> -->
                <div class="col text-end p-0">
                  <a
                    class="forgot-password"
                    routerLink="/forgot-password"
                    [queryParams]="{ request_id: request_id, client_id: client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }"
                    >Forgot Password?</a
                  >
                </div>
              </div>
              <ng-container *ngIf="captcha.enabled">
                <input type="hidden" formControlName="captcha_response" name="captcha_response" id="captcha_response" class="mt-5" />
                <div class="form-group mt-4">
                  <re-captcha (resolved)="resolved($event)" [siteKey]="captcha.site_key"></re-captcha>
                  <div class="tx-danger pd-t-10" *ngIf="captcha.enabled && !captcha.verified && submitted">Captcha is required</div>
                </div>
              </ng-container>
              <div class="d-grid" [class.cursor-not-allowed]="loginForm.invalid">
                <button type="submit" class="btn btn-hover" [disabled]="!valid()">Login</button>
              </div>
            </form>
          </ng-container>
          <div class="divider" *ngIf="publicLoginInfo?.login_providers && publicLoginInfo?.login_providers.length > 0 && publicLoginInfo.enable_classical">or login with</div>
          <div class="mx-auto row text-center" *ngIf="publicLoginInfo?.login_providers && publicLoginInfo?.login_providers.length > 0">
            <ng-container *ngIf="publicLoginInfo.login_providers">
              <div class="col gx-3">
                <ng-container *ngFor="let provider of publicLoginInfo.login_providers; trackBy: trackByFn">
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'google'">
                    <img src="assets/images/google.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'linkedin'">
                    <img src="assets/images/linkedin.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'facebook'">
                    <img src="assets/images/facebook.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'github'">
                    <img src="assets/images/github.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'amazon'">
                    <img src="assets/images/amazon.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'paypal_sandbox'">
                    <img src="assets/images/paypal_sandbox.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'salesforce'">
                    <img src="assets/images/salesforce.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'wordpress'">
                    <img src="assets/images/wordpress.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'yahoo'">
                    <img src="assets/images/yahoo.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'twitter'">
                    <img src="assets/images/twitter.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'foursquare'">
                    <img src="assets/images/foursquare.svg" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginwithSocial(provider)" [title]="provider.provider_display_name" class="btn" type="button" *ngIf="provider.provider_name == 'office365'">
                    <img src="assets/images/office-365.png" alt="Logo" width="35" height="35" />
                  </button>
                  <button (click)="loginWithSaml(provider.provider_name)" [title]="provider.provider_name" class="btn" type="button" *ngIf="provider.provider_name == 'SAML'">
                    <ng-container *ngIf="provider.logo_uri && provider.logo_uri != ''">
                      <img [src]="provider.logo_uri" alt="" style="height: 30px; width: auto" />
                    </ng-container>
                    <ng-container *ngIf="(provider.logo_uri && provider.logo_uri == '') || !provider.logo_uri">
                      <img src="https://skillmine-auth-admin.firebaseapp.com/assets/img/brand/logo_symbol.png" alt="logo" style="height: 30px; width: auto" width="35" height="35" />
                    </ng-container>
                  </button>
                  <button
                    (click)="loginwithSocial(provider)"
                    [title]="provider.provider_display_name"
                    class="btn"
                    type="button"
                    *ngIf="
                      provider.provider_name != 'SAML' &&
                      provider.provider_name != 'google' &&
                      provider.provider_name != 'office365' &&
                      provider.provider_name != 'foursquare' &&
                      provider.provider_name != 'facebook' &&
                      provider.provider_name != 'twitter' &&
                      provider.provider_name != 'linkedin' &&
                      provider.provider_name != 'github' &&
                      provider.provider_name != 'amazon' &&
                      provider.provider_name != 'yahoo' &&
                      provider.provider_name != 'salesforce' &&
                      provider.provider_name != 'wordpress' &&
                      provider.provider_name != 'paypal_sandbox'
                    ">
                    <ng-container *ngIf="provider.logo_uri && provider.logo_uri != ''">
                      <img [src]="provider.logo_uri" alt="logo" style="height: 30px; width: auto" width="35" height="35" />
                    </ng-container>
                    <ng-container *ngIf="(provider.logo_uri && provider.logo_uri == '') || !provider.logo_uri">
                      <img src="https://skillmine-auth-admin.firebaseapp.com/assets/img/brand/logo_symbol.png" alt="logo" style="height: 30px; width: auto" width="35" height="35" />
                    </ng-container>
                  </button>
                </ng-container>
              </div>
            </ng-container>
          </div>
          <div class="row text-center align-items-center mt-4">
            <p class="bottom-description mb-3" *ngIf="is_federation_login">
              Signin as a
              <a
                class="bottom-link"
                [routerLink]="['/federation-login']"
                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }"
                >federation login?</a
              >
            </p>
            <p class="bottom-description mb-3" *ngIf="isPasswordlessEnabled">
              Signin as a
              <a
                class="bottom-link"
                [routerLink]="['/passwordless']"
                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }"
                >passwordless login?</a
              >
            </p>
            <!-- <p class="bottom-description mb-3" *ngIf="isSingleLeggedEnabled">
              Signin as a
              <a href="javascript: void(0)" (click)="singleRedirection()" class="bottom-link">single legged login?</a>
            </p> -->
            <p class="bottom-description mb-3" *ngIf="isRegisterEnabled">
              Don’t have an account?
              <a
                class="bottom-link"
                [routerLink]="['/register']"
                [queryParams]="{ request_id: queryParams.request_id, client_id: queryParams.client_id, provider_name: queryParams.provider_name, provider_type: queryParams.provider_type }"
                >Create an account</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
